import { z } from 'zod';

// Auth schemas
export const loginSchema = z.object({
  email: z.string().email('Email inválido'),
  password: z.string().min(6, 'La contraseña debe tener al menos 6 caracteres'),
});

export const registerSchema = z.object({
  name: z.string().min(2, 'El nombre debe tener al menos 2 caracteres'),
  email: z.string().email('Email inválido'),
  password: z.string().min(6, 'La contraseña debe tener al menos 6 caracteres'),
  confirmPassword: z.string(),
}).refine((data) => data.password === data.confirmPassword, {
  message: "Las contraseñas no coinciden",
  path: ["confirmPassword"],
});

// Ingreso schemas
export const ingresoSchema = z.object({
  concepto: z.string().min(1, 'El concepto es requerido'),
  monto: z.number().positive('El monto debe ser positivo'),
  fecha: z.date(),
  categoria: z.string().min(1, 'La categoría es requerida'),
  descripcion: z.string().optional(),
});

// Egreso schemas
export const egresoSchema = z.object({
  concepto: z.string().min(1, 'El concepto es requerido'),
  monto: z.number().positive('El monto debe ser positivo'),
  fecha: z.date(),
  categoria: z.string().min(1, 'La categoría es requerida'),
  descripcion: z.string().optional(),
  esGastoFijo: z.boolean().optional(),
});

// Inversión schemas
export const inversionSchema = z.object({
  concepto: z.string().min(1, 'El concepto es requerido'),
  monto: z.number().positive('El monto debe ser positivo'),
  fecha: z.date(),
  tipo: z.enum(['acciones', 'bonos', 'fondo_mutuo', 'criptomonedas', 'cedears', 'obligacion_negociable', 'otros']),
  descripcion: z.string().optional(),
});

// Proyección schemas
export const proyeccionSchema = z.object({
  montoInicial: z.number().positive('El monto inicial debe ser positivo'),
  tasaInteres: z.number().min(0).max(100, 'La tasa de interés debe estar entre 0 y 100'),
  años: z.number().positive('Los años deben ser positivos'),
  aporteMensual: z.number().min(0, 'El aporte mensual no puede ser negativo'),
});

export type LoginFormData = z.infer<typeof loginSchema>;
export type RegisterFormData = z.infer<typeof registerSchema>;
export type IngresoFormData = z.infer<typeof ingresoSchema>;
export type EgresoFormData = z.infer<typeof egresoSchema>;
export type InversionFormData = z.infer<typeof inversionSchema>;
export type ProyeccionFormData = z.infer<typeof proyeccionSchema>;
